import { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom"; // ✅ import navigate
import Sidebar from "../components/Sidebar";
import { RevenueChart, FormsStatusChart } from "../components/Charts";
import OrdersTable from "../components/OrdersTable";
import {
  FileText,
  CreditCard,
  CheckCircle,
  TrendingUp
} from "lucide-react";
import api from "../api";

export default function Dashboard() {
  const navigate = useNavigate(); // ✅ initialize navigate
  const currentYear = new Date().getFullYear();

const [selectedYear, setSelectedYear] = useState(currentYear);
const [availableYears, setAvailableYears] = useState([]);

  const [statusCounts, setStatusCounts] = useState({
    formCreated: 0,
    totalTransactions: 0,
    successTransactions: 0,
    revenueGrowth: "",
    successRate: null,
  });
  


  useEffect(() => {
    const loadDashboardDetails = async () => {
      try {
        const token = localStorage.getItem("jwt"); // ✅ check sessionStorage

        if (!token) {
          // ✅ redirect if no token
          navigate("/login");
          return;
        }

        // ✅ Fetch dashboard summary
        const res = await api.post("payment/fetchDashBoardDetails", {},{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = res.data;

        // ✅ Fetch monthly metrics
        const metricsRes = await api.post(`/forms/metrics/monthly/all?year=${selectedYear}`,{}, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

       const metrics = metricsRes.data.metrics || [];
const years = metricsRes.data.years || [];

setAvailableYears(years);

        // Get latest month (last item in array)
        const latest = metrics[metrics.length - 1];
        const successRate =
          latest && latest.total > 0
            ? ((latest.success / latest.total) * 100).toFixed(1)
            : null;

        setStatusCounts({
          formCreated: data.formCreated || 0,
          totalTransactions: data.totalTransactions || 0,
          successTransactions: data.successTransactions || 0,
          revenueGrowth: data.revenueGrowth || "",
          successRate,
        });
      } catch (err) {
        console.error("Error fetching dashboard details:", err);
      }
    };

    loadDashboardDetails();
  }, [navigate,selectedYear]);

  return (
    <div className="px-shell">
      <Sidebar />

      <main className="px-main">
 <h2 className="px-title">Merchant Insights</h2>
<div className="px-sub">
  Track your forms and payments at a glance
</div>


        <Row className="mb-4">
          <Col md="3">
            <div className="px-summary-item">
              <div className="px-summary-icon">
                <FileText size={18} />
              </div>
              <div>
                <span>Forms Created</span>
                <strong>{statusCounts.formCreated}</strong>
              </div>
            </div>
          </Col>

          <Col md="3">
            <div className="px-summary-item">
              <div className="px-summary-icon">
                <CreditCard size={18} color="#0ea5e9" />
              </div>
              <div>
                <span>Total Transactions</span>
                <strong>{statusCounts.totalTransactions}</strong>
              </div>
            </div>
          </Col>

          <Col md="3">
            <div className="px-summary-item">
              <div className="px-summary-icon">
                <CheckCircle size={18} color="#16a34a" />
              </div>
              <div>
                <span>Successful Transactions</span>
                <strong>{statusCounts.successTransactions}</strong>
              </div>
            </div>
          </Col>

          <Col md="3">
            <div className="px-summary-item">
              <div className="px-summary-icon">
                <TrendingUp size={18} color="#f59e0b" />
              </div>
              <div>
                <span>Success Rate (Latest Month)</span>
                <strong>
                  {statusCounts.successRate !== null
                    ? `${statusCounts.successRate}%`
                    : "N/A"}
                </strong>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-4">
                    <Col md="4">
            <div className="px-card">
              <h6>Forms Activity</h6>
              <FormsStatusChart />
            </div>
          </Col>
        <Col md="8">
  <div className="px-card">

    <div className="d-flex justify-content-between align-items-center mb-3">
      <h6 className="mb-0">Transactions</h6>

      <select
        value={selectedYear}
        onChange={(e) =>
          setSelectedYear(Number(e.target.value))
        }
        className="form-select"
        style={{
          width: "120px",
        }}
      >
        {availableYears.map((year) => (
          <option
            key={year}
            value={year}
          >
            {year}
          </option>
        ))}
      </select>
    </div>
<RevenueChart selectedYear={selectedYear} />
    {/* <div
      style={{
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      <div style={{ minWidth: "1200px" }}>
        <RevenueChart selectedYear={selectedYear} />
      </div>
    </div> */}

  </div>
</Col>

        </Row>

        <div className="px-card mt-4">
          <h6>Recent Forms</h6>
          <OrdersTable />
        </div>
      </main>
    </div>
  );
}
